import React from 'react'
import { Row, Col } from 'antd'
import { GraviButton } from '@gravitate-js/excalibrr'
import { PlusCircleFilled, CloseCircleFilled } from '@ant-design/icons'

export const CreateHeader = ({ setCreatingDriver }) => {
  return (
    <Row>
      <Col className='create-new-driver-header' span={12}>
        Create New Driver
      </Col>
      <Col span={12} align='right'>
        <GraviButton
          theme2
          appearance='outlined'
          className='mr-2'
          onClick={() => {
            setCreatingDriver(false)
          }}
          buttonText='Cancel'
          icon={<CloseCircleFilled />}
        />
        <GraviButton
          htmlType='submit'
          theme2
          buttonText='Create Driver'
          icon={<PlusCircleFilled className='create-driver-icon' />}
          data-cy='create-driver-btn'
        />
      </Col>
    </Row>
  )
}
